export const UserRoles = {
  PARTNER: "partner", // business person access dashboard
  OWNER: "owner", // business owner
  ADMIN: "admin", //obby admin
  STAFF: "staff", // obby person
  MANAGER: "manager" // obby manager
};
